import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const CARDS = [
  {
    to: '/contact',
    titleKey: 'support.cards.contact.title',
    descKey: 'support.cards.contact.desc',
    tagKeys: ['support.cards.contact.tags.input', 'support.cards.contact.tags.attach', 'support.cards.contact.tags.email'],
    color: 'blue',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
      </svg>
    ),
  },
  {
    to: '/qna',
    titleKey: 'support.cards.qna.title',
    descKey: 'support.cards.qna.desc',
    tagKeys: ['support.cards.qna.tags.faq'],
    color: 'green',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    ),
  },
] as const

const COLOR_CLASSES: Record<string, { bg: string; text: string; hoverBorder: string; hoverBg: string }> = {
  blue: { bg: 'bg-blue-100', text: 'text-blue-600', hoverBorder: 'hover:border-blue-500', hoverBg: 'hover:bg-blue-50' },
  green: { bg: 'bg-green-100', text: 'text-green-600', hoverBorder: 'hover:border-green-500', hoverBg: 'hover:bg-green-50' },
}

export default function SupportPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="h-12 bg-slate-900 flex items-center gap-3 px-4 shrink-0">
        <button
          onClick={() => navigate('/dashboard')}
          className="text-xs text-slate-400 hover:text-white border border-slate-600 hover:border-slate-400 rounded px-3 py-1 transition-colors flex items-center gap-1.5"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          {t('support.back')}
        </button>
        <h1 className="text-white text-sm font-semibold ml-1">{t('dashboard.header.supportTitle')}</h1>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <p className="text-sm text-slate-500 mb-6">{t('support.ask')}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {CARDS.map(c => {
            const cls = COLOR_CLASSES[c.color]
            return (
              <button
                key={c.to}
                onClick={() => navigate(c.to)}
                className={`group p-5 rounded-xl border-2 border-slate-200 text-left flex flex-col gap-3 bg-white transition-all ${cls.hoverBorder} ${cls.hoverBg}`}
              >
                <div className={`w-10 h-10 rounded-lg ${cls.bg} ${cls.text} flex items-center justify-center`}>
                  {c.icon}
                </div>
                <div>
                  <p className="text-sm font-bold text-slate-800 mb-1">{t(c.titleKey)}</p>
                  <p className="text-[11px] text-slate-500 leading-relaxed">{t(c.descKey)}</p>
                </div>
                <div className="flex flex-wrap gap-1 mt-auto">
                  {c.tagKeys.map(tagKey => (
                    <span key={tagKey} className="text-[10px] px-2 py-0.5 bg-slate-100 text-slate-500 rounded font-medium">{t(tagKey)}</span>
                  ))}
                </div>
              </button>
            )
          })}
        </div>
      </main>
    </div>
  )
}
